import { types } from 'mobx-state-tree';
import { blockScroll, unblockScroll } from '../../util/dom';

const Modal = types
  .model('Modal', {
    isOpen: types.optional(types.boolean, false),
  })
  .actions((self) => {
    return {
      toggle(useBlockScroll = true, state = null) {
        self.isOpen = state || !self.isOpen;
        if (useBlockScroll) {
          self.isOpen ? blockScroll() : unblockScroll();
        }
      },
      close(useBlockScroll = true) {
        if (!self.isOpen) {
          return;
        }
        self.isOpen = false;
        if (useBlockScroll) {
          unblockScroll();
        }
      },
      open(useBlockScroll = true) {
        if (self.isOpen) {
          return;
        }
        self.isOpen = true;
        if (useBlockScroll) {
          blockScroll();
        }
      },
    };
  });

export default Modal;
